import React from "react";
import { useHistory, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import CircularProgress from "@mui/material/CircularProgress";
import { Formik } from "formik";
import {
  Grid,
  Typography,
  Card,
  Divider,
  Box,
  TableContainer,
  Table,
  TableRow,
  TableCell,
  TableBody,
  Autocomplete,
  Checkbox, FormControlLabel, 
} from "@mui/material";
import Button from "@mui/material/Button";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import MenuItem from "@mui/material/MenuItem";
import FormHelperText from "@mui/material/FormHelperText";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import AddIcon from "@mui/icons-material/Add";
import Select from "@mui/material/Select";
import api from "../../../components/services/api";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { makeStyles } from "@mui/styles";
const useStyles = makeStyles({
  customOutline: {
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "red",
    },
  },
});
export default function EditTrainroute() {
  const history = useHistory();
  const classes = useStyles();

  const [countryData, setCountryData] = useState([]);

  const [country, setCountry] = useState("");
  const [edit, setEdit] = useState({});
  const [detail, setdetail] = useState([])
  // console.log(detail?.Status);
  const EmpId = localStorage.getItem("EmpId");
  const [open, setOpen] = useState(false);
  const [StationName, setStationName] = useState("");
  const [ETAETD, setETAETD] = useState("");
  const [TravelTime, setTravelTime] = useState("");
  const [itemId, setItemID] = useState(null);
  let { id } = useParams();
  const data_params = { TrainRouteId: id };
  const [Station, setStation] = useState([]);
  const [MasterCost, setMasterCost] = useState([])
  const [currency, setCurrency] = useState([]);
  // console.log(Station);
  const [rows, setRows] = useState([]);
  function addRow() {
    const newRow = {
      id: rows?.slice(-1)[0]?.id ? rows?.slice(-1)[0]?.id + 1 : 1,
      CostId: "",
      CostPrice: 0,
      CurrencyId: "",
      CostPerContainer: true
    };

    setRows([...rows, newRow]);
  }
  const deletehand = (i) => {

    const data = rows?.filter((e, id) => i !== id);
    setRows(data);
  };
  const SelectCountry = (event) => {
    setCountry(event.target.value);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };
  const delete_mt_stel = (data) => {
    Station.splice(data, 1);
    setStation([...Station]);
  };

  const handleSave = () => {
    const data = {
      StationName: StationName,
      ETAETD: ETAETD,
      TravelTime: TravelTime,
      Status: 1
    };
    if (itemId !== null) {
      Station.map((x, i) => {
        if (i === itemId) {
          // return {
          x.StationName = StationName;
          x.ETAETD = ETAETD;
          x.TravelTime = TravelTime;
          // }

        }
        // console.log(Station);
        setStation([...Station]);
      });
    } else {
      setStation([...Station, data]);
    }
    setStationName("");
    setETAETD("1");
    setTravelTime("");
    setOpen(false);
    setItemID(null)
  };
  const handleEdit = (data) => {
    setOpen(true);
    setEdit(data);
    setStationName(data.StationName);
    setETAETD(data.ETAETD);
    setTravelTime(data.TravelTime);
    setItemID(data.id);

  };

  const handleClose = () => {

    setStationName("");
    setETAETD("");
    setTravelTime("");
    setOpen(false);
    setItemID(null)
  };
  const getdata = async () => {
    const data = await api.post(`api/trainroute/detail`, data_params)
    const result = data?.data
    setdetail(result);
    setStation(result?.Station)
    setRows(result?.TrainRouteCostDetails)


  }
  useEffect(() => {
    getdata()
    const getMasterCost = async () => {
      try {
        const res = await api.get(`/api/master/cost/Sale%20Order%20Cost`);
        setMasterCost(res?.data);

        //   setLog_data_length(3);
      } catch (e) {
        console.log(e);
      }
    };
    const getCurrency = async () => {
      try {
        const res = await api.get(`api/master/currency`);
        setCurrency(res?.data);

        //   setLog_data_length(3);
      } catch (e) {
        console.log(e);
      }
    };
    getCurrency()
    getMasterCost()
  }, [])

  return (
    <div>
      <Card variant="outlined" style={{ padding: "20px", margin: "25px" }}>
        <h6 style={{ marginTop: "10px" }} className="textcolorgreen">
          เส้นทางเดินรถไฟ
        </h6>

        <Grid container alignItems="center" spacing={1}>
          <Grid item xs>
            <Typography
              className="textcolordarkblue"
              variant="h5"
              component="h1"
            >
              Train Route
            </Typography>
          </Grid>
          <Grid item sx={{ display: "flex", flexDirection: "row" }}>
            <Typography className="textcolorBule">Setting</Typography>
            <Typography>
              <span>&nbsp;</span> / Train Route
            </Typography>
          </Grid>
        </Grid>

        <Formik
          enableReinitialize
          initialValues={{
            Routename: detail?.RouteName,
            RouteCode: detail?.RouteCode,
            RouteType: detail?.RouteType,
            Bogie: detail?.Bogie,
            Tues: detail?.Tues,
            Status: detail?.Status ? detail?.Status === true ? 1 : 0 : 0,
          }}
          validate={(values) => {
            const errors = {};
            if (!values.Routename || values.Routename == "") {
              errors.Routename = " * Required";
            }

            return errors;
          }}
          onSubmit={(values, { setSubmitting }) => {
            setTimeout(() => {
              const data = {
                TrainRouteId: detail?.TrainRouteId,
                RouteName: values.Routename,
                RouteCode: values.RouteCode,
                RouteType: values.RouteType,
                Bogie: values.Bogie,
                Tues: values.Tues,
                Status: values.Status,
                CreateId: EmpId,
                Station: Station,
                TrainRouteCostDetail: rows

              };

              api
                .post("/api/trainroute/update", data)
                .then((respose) => {
                  const MySwal = withReactContent(Swal);

                  MySwal.fire({
                    icon: "success",
                    didOpen: () => {
                      MySwal.clickConfirm();
                    },
                  }).then(() => {
                    return MySwal.fire(
                      "สำเร็จ!",
                      "อัพเดททางเดินรถไฟสำเร็จ !",
                      "success"
                    ).then((result) => {
                      if (result.isConfirmed) {
                        history.push("/Setting/TrainRoute");
                      }
                    });
                  });
                  console.log(respose);
                })
                .catch((err) => {
                  console.log(err);
                });
              // alert(JSON.stringify(data, null, 2));
              setSubmitting(false);
            }, 400);
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            /* and other goodies */
          }) => (
            <form onSubmit={handleSubmit} style={{ margin: "20px" }}>
              <h6 style={{ marginTop: "10px" }} className="textcolordarkblue">

              </h6>
              <Grid container>
                <Grid item xs={4} sm={4} md>
                  <TextField
                    name="Routename"
                    label="Route Name"
                    variant="outlined"
                    color="success"

                    placeholder="Route Name"
                    style={{
                      width: "100%",
                      marginTop: "10px",
                    }}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    InputLabelProps={{ shrink: true }}
                    value={values.Routename}
                    classes={{ root: !values.Routename ? classes.customOutline : null }}
                    required
                  /></Grid>
                  <Grid item xs={12} md={6}>

                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      name="RouteCode"
                      label="Route Code"
                      variant="outlined"
                      color="success"
                      placeholder="Route Code"
                      style={{
                        width: "100%",
                        marginTop: "10px",
                      }}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      InputLabelProps={{ shrink: true }}
                      value={values.RouteCode}
                      classes={{ root: !values.RouteCode ? classes.customOutline : null }}
                      required
                    />
                  </Grid>
                  <Grid item xs={12} md={6}></Grid>
                  <Grid item xs={12} md={6}>

                  <FormControl style={{ marginTop: "10px" }} required classes={{ root: !values.RouteType ? classes.customOutline : null }}
                    fullWidth>
                    <InputLabel id="select_status-label">Type</InputLabel>
                    <Select
                      name="RouteType"
                      id="Type"
                      value={values.RouteType || ''}
                      label="Type"
                      sx={{
                        width: "100%",

                        marginBottom: "10px",
                      }}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    >
                      <MenuItem value='เหมา'>เหมา</MenuItem>
                      <MenuItem value='ปลีกย่อย'>ปลีกย่อย</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12}>

                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    name="Bogie"
                    label="Wagon"
                    variant="outlined"
                    color="success"
                    placeholder="Wagon"
                    style={{
                      width: "100%",
                      marginTop: "10px",
                    }}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    InputLabelProps={{ shrink: true }}
                    value={values.Bogie}
                    classes={{ root: values.Tues === '' ? classes.customOutline : null }}
                    required
                  />
                </Grid>
                <Grid item xs={6}>

                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    name="Tues"
                    label="Tues"
                    variant="outlined"
                    color="success"
                    placeholder="Tues"
                    style={{
                      width: "100%",
                      marginTop: "10px",
                    }}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    InputLabelProps={{ shrink: true }}
                    value={values.Tues}
                    classes={{ root: values.Tues === '' ? classes.customOutline : null }}
                    required
                  />
                </Grid>
                <Grid item xs={12} md={6}></Grid>
                  {/* {errors.Routename && touched.Routename && errors.Routename} */}
                  <Grid item xs={12} md={6}>

                  <FormControl style={{ marginTop: "10px" }} fullWidth>
                    <InputLabel id="select_status-label">Status</InputLabel>
                    <Select
                      name="Status"
                      id="Status"
                      value={values.Status}
                      label="Status"
                      sx={{
                        width: "100%",

                        marginBottom: "10px",
                      }}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    >
                      <MenuItem value={1}>Active</MenuItem>
                      <MenuItem value={0}>InActive</MenuItem>
                    </Select>
                  </FormControl>
                  </Grid>
                  <Grid item xs={12} md={6}></Grid>

                  <Button
                  type="button"
                  variant="contained"
                  // disabled={costType ? false : true}
                  style={{
                    background: "#80c340",
                    borderColor: "#80c340",
                    marginTop: "10px",
                  }}
                  onClick={addRow}
                >
                  <AddIcon /> Add
                </Button>
                <TableContainer sx={{ marginTop: 2, marginBottom: 2 }}>
                  <Table stickyHeader>
                    <TableRow>
                      <TableCell align="center" width="5%">
                        #
                      </TableCell>
                      <TableCell align="center" width="15%">
                        Charge
                      </TableCell>
                      <TableCell align="center" width="10%">
                        Quantity
                      </TableCell>
                      <TableCell align="center" width="15%">
                        Price
                      </TableCell>
                      <TableCell align="center" width="10%">
                        Currency
                      </TableCell>

                      {/* <TableCell align="center" width="15%">TaxTotal</TableCell> */}
                      <TableCell align="center" width="10%"></TableCell>
                    </TableRow>
                    {rows?.map((data, index) => {
                      return (
                        <TableBody key={index}>
                          <TableCell align="center">{index + 1}</TableCell>
                          <TableCell align="center">
                            {/* <FormControl fullWidth>
                        <InputLabel>Charge</InputLabel>
                        <Select
                          label="Charge"
                          value={data?.CostId || ''}
                          InputLabelProps={{ shrink: true }}
                          onChange={(e) => {
                            const io = rows?.map((v) => {
                              v.CostId =
                                v?.id === data?.id ? e.target.value : v?.CostId;
                              v.Cost =
                                v?.id === data?.id ? MasterCost.find(x => x?.CostId === e.target.value) : v?.Cost;
                              v.CostPrice =
                                v?.id === data?.id ? MasterCost.find(x => x?.CostId === e.target.value)?.CostPrice : +v?.CostPrice;
                              v.CurrencyId =
                                v?.id === data?.id ? MasterCost.find(x => x?.CostId === e.target.value)?.CurrencyId : v?.CurrencyId;

                              return v;
                            });

                            setRows([...io]);
                          }}
                        >
                          {MasterCost?.map((x) =>
                            <MenuItem value={x?.CostId}>{x?.CostName}</MenuItem>
                          )}
                        </Select>
                      </FormControl> */}
                            <Autocomplete
                              // freeSolo
                              fullWidth
                              options={MasterCost}
                              getOptionLabel={(option) => option?.CostName}
                              // renderOption={(props, option) => (
                              //   <Box component="li" {...props} key={option.EmpNo}>
                              //     {option?.firstname} {option?.lastname}</Box>
                              // )}

                              id="controlled-demo"
                              value={data?.Cost}
                              onChange={(event, newValue) => {
                                const io = rows?.map((v) => {
                                  v.Cost =
                                    v?.id === data?.id ? newValue : v?.Cost;
                                  v.CostId =
                                    v?.id === data?.id
                                      ? newValue?.CostId
                                      : v?.CostId;
                                  v.Cost =
                                    v?.id === data?.id
                                      ? MasterCost.find(
                                          (x) => x?.CostId === newValue?.CostId
                                        )
                                      : v?.Cost;
                                  v.CostPrice =
                                    v?.id === data?.id
                                      ? MasterCost.find(
                                          (x) => x?.CostId === newValue?.CostId
                                        )?.CostPrice
                                      : +v?.CostPrice;
                                  v.CurrencyId =
                                    v?.id === data?.id
                                      ? MasterCost.find(
                                          (x) => x?.CostId === newValue?.CostId
                                        )?.CurrencyId
                                      : v?.CurrencyId;

                                  return v;
                                });

                                setRows([...io]);
                              }}
                              selectOnFocus
                              clearOnBlur
                              handleHomeEndKeys
                              renderInput={(params) => (
                                <TextField {...params} label="Charge" />
                              )}
                            />
                          </TableCell>

                          <TableCell align="center">
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={data?.CostPerContainer || ""}
                                  onChange={(e) => {
                                    const io = rows?.map((v) => {
                                      v.CostPerContainer =
                                        v?.id === data?.id
                                          ? e.target.checked
                                          : v?.CostPerContainer;

                                      return v;
                                    });

                                    setRows([...io]);
                                  }}
                                />
                              }
                              label="per CNTR"
                            />
                          </TableCell>
                          <TableCell align="center">
                            <TextField
                              label="Price"
                              value={data?.CostPrice || ""}
                              type="number"
                              onChange={(e) => {
                                const io = rows?.map((v) => {
                                  v.CostPrice =
                                    v?.id === data?.id
                                      ? +e.target.value
                                      : +v?.CostPrice;

                                  return v;
                                });

                                setRows([...io]);
                              }}
                            />
                          </TableCell>
                          <TableCell align="center">
                            <FormControl fullWidth>
                              <InputLabel>Currency</InputLabel>
                              <Select
                                label="Currency"
                                value={data?.CurrencyId || ""}
                                InputLabelProps={{ shrink: true }}
                                onChange={(e) => {
                                  const io = rows?.map((v) => {
                                    v.CurrencyId =
                                      v?.id === data?.id
                                        ? e.target.value
                                        : v?.CurrencyId;

                                    return v;
                                  });

                                  setRows([...io]);
                                }}
                              >
                                {currency?.map((x) => (
                                  <MenuItem value={x?.CurrencyId}>
                                    {x?.CurrencyCode}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </TableCell>

                          <TableCell align="center">
                            <Button
                              type="button"
                              variant="outlined"
                              style={{
                                color: "#80c340",
                                borderColor: "#80c340",
                              }}
                              onClick={() => deletehand(index)}
                            >
                              Delete
                            </Button>
                          </TableCell>
                        </TableBody>
                      );
                    })}
                  </Table>
                </TableContainer>
                  {/* <Grid item xs={12}></Grid>
                  <Button
                    type="button"
                    variant="contained"
                    style={{
                      background: "#80c340",
                      borderColor: "#80c340",
                      marginTop: "10px",
                    }}
                    onClick={() => setOpen(true)}
                  >
                    <AddIcon /> Add Row
                  </Button>
                  {Station.length > 0 ? (
                    <TableContainer sx={{ marginTop: 2, marginBottom: 2 }}>
                      <Table stickyHeader>
                        <TableRow>
                          <TableCell align="center">#</TableCell>
                          <TableCell align="center">StationName</TableCell>
                          <TableCell align="center">ETAETD</TableCell>
                          <TableCell align="center">TravelTime</TableCell>
                          <TableCell align="center"></TableCell>
                        </TableRow>
                        {Station.map((data, index) => {
                          return (
                            <TableBody>
                              <TableCell align="center">{index + 1}</TableCell>
                              <TableCell align="center" width="25%">
                                {data.StationName}
                              </TableCell>
                              <TableCell align="center">
                                {data.ETAETD}
                              </TableCell>
                              <TableCell align="center">
                                {data.TravelTime}
                              </TableCell>

                              <TableCell align="right">
                                <Button
                                  onClick={() =>
                                    handleEdit({
                                      id: index,
                                      ...data,
                                    })
                                  }
                                  variant="contained"
                                  type="button"
                      
                                  style={{
                                    background: "#80c340",
                                    borderColor: "#80c340",
                                 
                                  }}
                                >
                                  Edit
                                </Button>
                                <Button
                                  onClick={() => delete_mt_stel(index)}
                                  variant="outlined"
                                  style={{
                                    marginLeft: "15px",
                                    borderColor: "#80c340",
                                    color: "#80c340",
                                  }}
                                >
                                  Delete
                                </Button>
                              </TableCell>
                            </TableBody>
                          );
                        })}
                      </Table>
                    </TableContainer>
                  ) : (
                    ""
                  )}
                </Grid> */}
                </Grid>
                <Button
                  type="button"
                  variant="outlined"
                  style={{
                    color: "#80c340",
                    borderColor: "#80c340",
                    marginRight: "10px",
                    marginTop: "20px",
                  }}
                  onClick={history.goBack}
                >
                  back
                </Button>
                <Button
                  type="submit"
                  variant="contained"
                  style={{
                    background: "#80c340",
                    borderColor: "#80c340",
                    marginRight: "10px",
                    marginTop: "20px",
                  }}
                  disabled={isSubmitting}
                >
                  {isSubmitting && <CircularProgress size={22} />}
                  {!isSubmitting && "SAVE"}
                </Button>
            </form>
          )}
        </Formik>
      </Card>
      <Dialog
        open={open}
        maxWidth="md"
        fullWidth="md"
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle></DialogTitle>
        <Box></Box>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item lg={4}>
              <Typography sx={{ marginLeft: "40px", alignItems: "center" }}>
                StationName
              </Typography>
            </Grid>
            <Grid item lg={8}>
              <TextField
                fullWidth
                variant="outlined"
                label="StationName"
                size="small"
                color="success"
                value={StationName}
                onChange={(e) => setStationName(e.target.value)}
                classes={{ root: !StationName ? classes.customOutline : null }}
              />
            </Grid>
            <Grid item lg={4}>
              <Typography sx={{ marginLeft: "40px", alignItems: "center" }}>
                ETAETD
              </Typography>
            </Grid>
            <Grid item lg={8}>
              <FormControl fullWidth classes={{ root: !ETAETD ? classes.customOutline : null }}>
                <InputLabel id="demo-simple-select-label" color="success">
                  ETAETD
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  color="success"
                  label="ETAETD"
                  size="small"
                  value={ETAETD}
                  onChange={(e) => setETAETD(e.target.value)}
                >
                  <MenuItem value="ETA">ETA</MenuItem>
                  <MenuItem value="ETD">ETD</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item lg={4}>
              <Typography sx={{ marginLeft: "40px", alignItems: "center" }}>
                TravelTime
              </Typography>
            </Grid>
            <Grid item lg={8}>
              <TextField
                fullWidth
                variant="outlined"
                label="TravelTime(min)"
                color="success"
                size="small"
                value={TravelTime}
                onChange={(e) => setTravelTime(e.target.value)}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleClose}
            variant="outlined"
            style={{
              color: "#80c340",
              borderColor: "#80c340",
              marginRight: "10px",
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={() => { if (StationName) { handleSave() } }}
            autoFocus
            variant="contained"
            style={{
              background: "#80c340",
              borderColor: "#80c340",
              marginRight: "10px",
              color: "#ffff",
            }}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
